import AxiosInstances from 'axios';
import qs from 'query-string';

const axios = AxiosInstances.create({
  baseURL: import.meta.env.VITE_API_URL,
  transitional: {
    clarifyTimeoutError: true,
  },
});

/*
 Convention: https://docs.google.com/document/d/1ePqfM41II2CNBYpTuOgjLZafRkn6vABQ5NF40JGER1E/edit
 Review Reference: https://docs.google.com/document/d/1Diu8ZwKXPOWCsH2ry8rufCYADGFcHtR4MY3k1c3Ypes/edit

 ! Review
 TODO dashboard - move to @oy/types
 */

// v1
export const ANNOUNCEMENT_PREFIX = '/feature-announcement/v1';
export const AUTH_PREFIX = '/business/auth/v1';
export const B2X_PREFIX_V1 = '/b2x/v1';
export const BULK_DISBURSE_PREFIX = '/channel/bulk-disbursement';
export const BUSINESS_PAYMENT_PREFIX = '/business/payment/v1';
export const ACCOUNTING_PLATFORM = `${BUSINESS_PAYMENT_PREFIX}/b2x/accounting-platform/v1`;
export const ACCOUNT_RECEIVABLE_PREFIX = `${BUSINESS_PAYMENT_PREFIX}/account-receivable`;
export const BUSINESS_PREFIX_V2 = '/business/v2';
export const CLAIM_FUND_PREFIX = '/claim-fund';
export const KYB_PREFIX = 'business/kyb/v1';
export const FORM_ACTIVATION_PAYMENT = '/business/kyb/ewallet/form';
export const FORM_ACTIVATION_PAYMENT_BCA = '/business/kyb/bca-va/form';
export const LOCATION = '/location/v1';
export const DANA_LOCATION_PREFIX = `${BUSINESS_PAYMENT_PREFIX}/location/dana`;
export const MULTI_ACCOUNT_PREFIX =
  '/business/payment/v1/account/multi-account';
export const AUTH_MULTI_ACCOUNT_PREFIX = '/business/auth/v1/multi-account';
export const NOTIFICATION_PREFIX = `${BUSINESS_PAYMENT_PREFIX}/notification`;
export const PAYMENT_PREFIX = '/api/v1/business-payment';
export const SCHEDULED_DISBURSE_PREFIX = '/api/scheduled-remit';
export const TOTP_PREFIX = '/totp';
export const TX_DATA_PREFIX = '/transaction-data';
export const VIRTUAL_CARD_PREFIX = '/business/payment/v1/virtual-card';
export const VIRTUAL_CARD_PUBLIC_PREFIX = '/b2x/v1/virtual-card';
export const PHYSICAL_CARD_PREFIX = `${BUSINESS_PAYMENT_PREFIX}/physical-card`;
export const PHYSICAL_CARD_PUBLIC_PREFIX = `/b2x/v2/pay/physical-card`;
export const TOKENIZATION_PREFIX = '/tokenization';
export const REIMBURSEMENT_PREFIX = `${BUSINESS_PAYMENT_PREFIX}/reimbursement`;
export const REIMBURSEMENT_PREFIX_PUBLIC = `${B2X_PREFIX_V1}/reimbursement`;

// v2
export const AUTH_PREFIX_V2 = '/business/auth/v2';

export const decodedUriParamsSerializer = (params: any) => {
  // fix issue where % in encoded URI re-encoded
  const decodedParams = Object.keys(params).reduce(
    (acc, key) => ({ ...acc, [key]: decodeURIComponent(params[key]) }),
    {},
  );
  return qs.stringify(decodedParams);
};

export default axios;
